import dynamic from 'next/dynamic';
import css from './index.module.scss';
import BannerModule from '@/components/ProductDetailComponents/BannerModule';
import { useGlobal } from '@/utils/useGlobal';

const Content = dynamic(() => import('./dynamicContent'), {
    ssr: true,
});

export default function SolarPanel() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('110wsolarpanel');
    const languageT = (value: string) => t(`solarpanels_110w.${value}`);
    const webpUrl = '/media/solarpanel_110w/pc/';

    const { locale } = useRouter();

    const bannerSpec: any = {
        us: '',
        eu: '_eu',
        uk: '_uk',
        de: '_eu',
        fr: '_eu',
        it: '_eu',
        es: '_eu',
    };

    const bannerData = [
        {
            bgImgs: [`1_banner${bannerSpec[locale] || bannerSpec.us}.webp`, `1_banner${bannerSpec[locale] || bannerSpec.us}.jpg`],
            title: languageT('title'),
            des: languageT('des'),
        },
    ];

    return (
        <div className={`${css.animationWrapper} solarPanelModule`}>
            <div style={{ width: '100%', marginTop: '-64px' }}>
                <BannerModule data={bannerData} config={{ isShowLogo: false, theme: 'black', webpUrl }} />
            </div>
            <Content />
        </div>
    );
}
